import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TradingViewComponent } from '@shared/components/trading/trading-view/trading-view.component'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'

@Component({
	selector: 'app-trading-view-widget',
	templateUrl: './trading-view-widget.component.html',
	styleUrl: './trading-view-widget.component.scss',
	imports: [TradingViewComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TradingViewWidgetComponent {
	@Input() widget: WidgetInterface | null = null
}
